/**
 * Attendee API Client
 * ===================
 *
 * This client is different than most of our other subclients. Instead of authenticating Splash Users,
 * it hits endpoints authenticated by Splash Attendees!
 */

export default class VirtualSettingsAttendeeApiClient {
    /**
     * Constructor.
     *
     * @param {string} guestAccessHash
     */
    constructor(apiClient, guestAccessHash = false) {
        this.setGuestAccessHash(guestAccessHash);
        this.apiClient = apiClient;
    }

    /**
     * The guest access hash is a character string generated by the Splash API that identifies the
     * current attendee as a specific GroupContact in the backend system. We use this magic
     * link to redeem an API access token to request data.
     *
     * @param {string} guestAccessHash
     */
    setGuestAccessHash(guestAccessHash) {
        this.guestAccessHash = guestAccessHash;
    }

    getVirtualEventSettings(eventId) {
        return this.apiClient.get(
            `/event/${eventId}/attendee/virtual`,
            {},
            {
                omitAccessToken: true,
                headers: {
                    'X-Splash-Guest-Access-Hash': this.guestAccessHash,
                },
            },
        );
    }

    putVirtualEventCheckIn(eventId, payload = {}) {
        return this.apiClient.put(`/event/${eventId}/attendee/virtual/checkin`, payload, {
            omitAccessToken: true,
            headers: {
                'X-Splash-Guest-Access-Hash': this.guestAccessHash,
            },
        });
    }

    /**
     * This is a strange one that doesn't use an async fetch, but the browser's
     * navigator.sendBeacon which sends a POST request with no way to get the
     * response from the server.
     */
    sendVirtualEventCheckOutBeacon(eventId, payload = {}) {
        return navigator.sendBeacon(
            this.apiClient.addAccessToken(this.apiClient.apiUrl(`/event/${eventId}/attendee/virtual/checkout`)),
            JSON.stringify(payload),
        );
    }
}
